export const version = '0.821.1'
export const chameleonWebVersion = '10.7.0'
export const chameleonCoreVersion = '7.15.1'
